// extracted by mini-css-extract-plugin
export default {"instruction":"IntegrationsWizard_instruction__zm3ax","description":"IntegrationsWizard_description__+ia01","content":"IntegrationsWizard_content__PC2Gl"};